import { jsx as _jsx } from "react/jsx-runtime";
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { keyframes } from '@emotion/core';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import styled from '@emotion/styled';
import { colors as dsColors } from '@modernhealth/vital-foundation';
import { pxToRem } from '../../helpers/pxToRem';
const Name = 'SkeletonPlaceholder';
export const SkeletonPlaceholder = ({ className, width, height, borderRadius = 4, marginTop = 0, marginRight = 0, marginBottom = 0, }) => {
    const backgroundColor = dsColors.gray20;
    const highlightColor = '#F2F8FC';
    return (_jsx(SkeletonContainer, { className: className, "data-component": Name, backgroundColor: backgroundColor, highlightColor: highlightColor, style: {
            backgroundColor,
            overflow: 'hidden',
            width: typeof width === 'number' ? pxToRem(width) : width,
            height: typeof height === 'number' ? pxToRem(height) : height,
            borderRadius: pxToRem(borderRadius),
            marginTop: pxToRem(marginTop),
            marginRight: pxToRem(marginRight),
            marginBottom: pxToRem(marginBottom),
        } }));
};
const skeletonKeyframes = keyframes `
  100% {
      transform: translateX(100%);
  }
`;
const SkeletonContainer = styled.div(({ backgroundColor, highlightColor }) => ({
    display: 'inline-block',
    position: 'relative',
    overflow: 'hidden',
    '&::after': {
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        transform: 'translateX(-100%)',
        backgroundImage: `linear-gradient(90deg, ${backgroundColor}, ${highlightColor}, ${highlightColor}, ${backgroundColor})`,
        animation: `${skeletonKeyframes} 1.5s infinite`,
        content: '""',
    },
}));
